import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { UserService } from 'src/app/admin/services/user.service';
import { AppUtils } from 'src/app/helpers/app.utils';
import { PageUrls } from 'src/app/helpers/page-urls';
import { Constants } from 'src/app/helpers/constants';
import { EditorAddModel } from 'src/app/admin/models/editor.add.model';

@Component({
    selector: 'app-user-add-editor',
    templateUrl: './user.add.editor.component.html'
})
export class UserAddEditorComponent implements OnInit {
    isModelLoaded = false;
    emailPattern: string;
    phoneMask: string;
    model: EditorAddModel = new EditorAddModel();
    confirmPassword: string;
    passwordPattern: string;

    constructor(private router: Router,
        private ngxSpinner: NgxSpinnerService,
        private toastr: ToastrService,
        private userService: UserService) {
    }

    get urls() {
        return PageUrls;
    }

    ngOnInit() {
        this.emailPattern = Constants.emailValidationRegEx;
        this.passwordPattern = Constants.passwordRegEx;
        this.phoneMask = Constants.phoneMask;
    }

    submit() {
        this.ngxSpinner.show();
        this.userService.addEditor(this.model).subscribe(
            () => {
                this.ngxSpinner.hide();
                this.router.navigateByUrl(`${PageUrls.Admin.UserEditor}`);
                setTimeout(() => {
                    this.toastr.success('Editor has been added successfully.');
                });
            },
            error => {
                this.ngxSpinner.hide();
                AppUtils.processErrorResponse(this.toastr, error);
            });
    }
}
